import { render, staticRenderFns } from "./LoginButtons.vue?vue&type=template&id=61e0a552&"
import script from "./LoginButtons.vue?vue&type=script&lang=js&"
export * from "./LoginButtons.vue?vue&type=script&lang=js&"
import style0 from "./LoginButtons.vue?vue&type=style&index=0&id=61e0a552&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports